import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";

import { setAlert } from "../../../actions/alertActions";
import { momentModule } from "../../utils/Utils";

import "../../../styles/components/chargers/modals/ConfigurationKeys.scss";
import { ReactComponent as PencilIcon } from "../../../styles/images/pencil.svg";
import { ReactComponent as ReloadIcon } from "../../../styles/images/reset_soft.svg";

const { moment, formatDate } = momentModule;

const chargetStatus = Object.freeze({
  ONLINE: "10",
});

class ConfigurationKeys extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      loading: false,
      mode: "keys",

      lists: [],
      keys: [],
      changedKeys: [],
      lastUpdated: null,

      selectedList: null,
    };

    this.handleOnUpdate = this.handleOnUpdate.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.dispatchConfigurationAction("getEvioKeys");
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting!");
  }

  dispatchConfigurationAction(action, config = {}) {
    const post = {
      chargerId: this.props.selectedCharger?.hwId,
      chargerType: this.props.selectedCharger?.chargerType,
      action,
      ...(action === "getConfigurationKeysDiff" && {
        evioKeysId: this.state.selectedList._id,
      }),
      ...((action === "getConfigurationKeysDiff" ||
        action === "changeConfiguration") && {
        hwId: this.props.selectedCharger?.hwId,
      }),
      ...(action === "changeConfiguration" && {
        configuration: this.state.changedKeys,
      }),
      ...config,
    };
    this.safeSetState({ loading: true }, () => {
      axios
        .post("/api/private/connectionstation", post, {
          cancelToken: new CancelToken((c) => (this.cancel = c)),
        })
        .then((res) => {
          if (res.status !== undefined && res.status === 200) {
            this.safeSetState({ loading: false }, () => {
              if (action === "getEvioKeys")
                this.safeSetState(
                  { lists: res.data, selectedList: res.data[0] },
                  () =>
                    this.dispatchConfigurationAction("getConfigurationKeysDiff")
                );
              else if (action === "getConfigurationKeysDiff")
                this.safeSetState({
                  keys: res.data.data,
                  lastUpdated: moment(res.data.lastReadDate),
                });
              else if (action === "changeConfiguration") {
                const { failedConfigurationKeys, successConfigurationKeys } =
                  res.data;
                if (
                  successConfigurationKeys?.length ===
                  this.state.changedKeys.length
                ) {
                  this.dispatchConfigurationAction("getConfigurationKeysDiff");
                  this.props.setAlert(
                    I18n.t("configurationKeys_updateSuccessful"),
                    "primary"
                  );
                } else if (
                  failedConfigurationKeys?.length ===
                  this.state.changedKeys.length
                ) {
                  this.props.setAlert(
                    I18n.t("configurationKeys_updateUnsuccessful"),
                    "danger"
                  );
                } else {
                  this.props.setAlert(
                    I18n.t("configurationKeys_updatePartiallySuccessful"),
                    "danger"
                  );
                }
              }
            });
          }
        })
        .catch((err) =>
          this.safeSetState({ loading: false }, () =>
            this.props.setAlert(I18n.t(err.response.data.message), "danger")
          )
        );
    });
  }

  handleSelectList(list) {
    this.safeSetState({ selectedList: list, mode: "keys" }, () =>
      this.dispatchConfigurationAction("getConfigurationKeysDiff")
    );
  }

  handleChangeKey(key, value) {
    const idx = this.state.changedKeys.findIndex(
      (keyObj) => keyObj.key === key
    );
    if (idx !== -1) {
      this.safeSetState((prevState) => ({
        changedKeys: [
          ...prevState.changedKeys.slice(0, idx),
          { key, value },
          ...prevState.changedKeys.slice(idx + 1),
        ],
      }));
    } else {
      const changedKeys = Array.from(this.state.changedKeys);
      changedKeys.push({ key, value });
      this.safeSetState({ changedKeys });
    }
  }

  handleOnUpdate() {
    if (this.state.changedKeys.length > 0)
      this.dispatchConfigurationAction("changeConfiguration");
    else
      this.props.setAlert(I18n.t("configurationKeys_noKeysToUpdate"), "danger");
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  resetState() {
    this.safeSetState({
      loading: false,
      mode: "keys",
      keys: [],
    });
  }

  render() {
    return (
      <Modal
        id="configurationKeys"
        show={this.props.show}
        onHide={this.props.onHide}
        onExited={this.resetState}
        centered
      >
        <Modal.Header>
          <div className="header-info">
            <p>
              <Translate value="configurationKeys_id" />:{" "}
              <b>{this.props.selectedCharger?.hwId}</b>
            </p>
            <p>
              <Translate value="configurationKeys_vendor" />:{" "}
              <b>{this.props.selectedCharger?.vendor}</b>
            </p>
            <p>
              <Translate value="configurationKeys_model" />:{" "}
              <b>{this.props.selectedCharger?.model}</b>
            </p>
            {this.props.selectedCharger?.firmwareVersion && (
              <p>
                Firmware: <b>{this.props.selectedCharger?.firmwareVersion}</b>
              </p>
            )}
          </div>
          <div className="config-list">
            <p>
              <Translate value="configurationKeys_configList" />:{" "}
            </p>
            <p>
              <b>{this.state.selectedList?.code}</b>
              <button
                type="button"
                className="clear"
                onClick={() => this.safeSetState({ mode: "lists" })}
              >
                <PencilIcon />
              </button>
            </p>
          </div>
        </Modal.Header>
        {this.state.mode === "keys" ? (
          <>
            <Modal.Body>
              <div className="table-container">
                <div className="table-header">
                  <div className="row no-gutters">
                    <div className="col-12 row no-gutters titles">
                      <div className="col title">
                        <Translate value="configurationKeys_key" />
                      </div>
                      <div className="col title">
                        <Translate value="configurationKeys_value" />
                      </div>
                      <div className="col title">
                        <Translate value="configurationKeys_listedValue" />
                      </div>
                      <div className="col title">
                        <Translate value="configurationKeys_newValue" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-values">
                  {!this.state.loading ? (
                    this.state.keys.length > 0 ? (
                      this.state.keys.map((key) => (
                        <div key={key._id} className="row no-gutters">
                          <div className="col-12 row no-gutters values slim">
                            <div
                              className={`col ${
                                key.currentValue ===
                                "configurationKeys_notFound"
                                  ? "unknown"
                                  : ""
                              }`}
                            >
                              {key.key}
                            </div>
                            <div className="col">
                              {key.currentValue ===
                              "configurationKeys_notFound" ? (
                                <Translate value="configurationKeys_notFound" />
                              ) : (
                                key.currentValue
                              )}
                            </div>
                            <div className="col">
                              {key.correctValue ===
                              "configurationKeys_notFound" ? (
                                <Translate value="configurationKeys_notFound" />
                              ) : (
                                key.correctValue
                              )}
                            </div>
                            <div className="col">
                              {key.readonly ? (
                                <Translate value="configurationKeys_readonly" />
                              ) : (
                                <input
                                  type="text"
                                  className={
                                    !this.state.changedKeys.some(
                                      (keyObj) => keyObj.key === key.key
                                    )
                                      ? "correctValue"
                                      : ""
                                  }
                                  defaultValue={
                                    key.currentValue?.toLowerCase?.() !==
                                      key.correctValue?.toLowerCase?.() &&
                                    key.correctValue !==
                                      "configurationKeys_notFound"
                                      ? key.correctValue
                                      : ""
                                  }
                                  onChange={(e) =>
                                    this.handleChangeKey(
                                      key.key,
                                      e.target.value
                                    )
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="no-keys">
                        <p>
                          <Translate value="configurationKeys_noKeys" />
                        </p>
                        <button
                          onClick={() =>
                            this.dispatchConfigurationAction(
                              "getConfigurationKeysDiff"
                            )
                          }
                        >
                          <Translate value="configurationKeys_getKeys" />
                        </button>
                      </div>
                    )
                  ) : (
                    <div className="loading-container">
                      <div className="loading-spinner">
                        <div className="generic-loading">
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="last-update-container">
                <p>
                  <Translate value="configurationKeys_lastUpdated" />:{" "}
                  {formatDate(this.state.lastUpdated, "datetime") || "-"}
                </p>
                <button
                  type="button"
                  className="clear"
                  onClick={() =>
                    this.dispatchConfigurationAction(
                      "getConfigurationKeysDiff",
                      { reload: true }
                    )
                  }
                >
                  <ReloadIcon />
                </button>
              </div>
            </Modal.Body>
            <Modal.Footer>
              {this.state.keys.length > 0 && (
                <button type="button" onClick={this.handleOnUpdate} disabled={this.props?.selectedCharger?.status !== chargetStatus.ONLINE ? true : false}>
                  <Translate value="configurationKeys_update" />
                </button>
              )}
            </Modal.Footer>
          </>
        ) : (
          <Modal.Body>
            <div className="lists-container">
              {this.state.lists.map((list) => (
                <div
                  className="list-container"
                  onClick={() => this.handleSelectList(list)}
                >
                  <p className="list-code">
                    <b>
                      <Translate value="configurationKeys_code" />:{" "}
                    </b>
                    {list.code}
                  </p>
                  <p className="list-manufacturer">
                    <b>
                      <Translate value="configurationKeys_manufacturer" />:{" "}
                    </b>
                    {list.manufacturer ?? "-"}
                  </p>
                  <p className="list-model">
                    <b>
                      <Translate value="configurationKeys_model" />:{" "}
                    </b>
                    {list.model ?? "-"}
                  </p>
                  <p className="list-description">
                    <b>
                      <Translate value="configurationKeys_description" />:{" "}
                    </b>
                    {list.description ?? (
                      <Translate value="configurationKeys_noDescription" />
                    )}
                  </p>
                </div>
              ))}
            </div>
          </Modal.Body>
        )}
      </Modal>
    );
  }
}

export default connect(null, { setAlert })(ConfigurationKeys);
